import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import AdbIcon from '@mui/icons-material/Adb';
import { useAccessContext } from '../contexts/access_context';

interface TopMenuProps {
  onSelect: (page: string) => void; // Propriedade para retornar o item selecionado
}

const options = {
  master: ['Escolas', 'Dashboard'],
  school: ['Alunos', 'Dashboard'],
  students: [''],
};


const TopMenu: React.FC<TopMenuProps> = ({ onSelect }) => {

  const { access_data } = useAccessContext();
  const pages = options[access_data.profile as keyof typeof options] || [];

  const handleMenuClick = (page: string) => {
    onSelect(page); // Notifica o módulo anterior sobre o item selecionado
  };

  // React.useEffect(() => {
  //   console.log("Atualizando menu para perfil:", access_data?.profile);
  // }, [access_data.profile]);

  return (
    <AppBar position="relative">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            self METRICS!
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => handleMenuClick(page)} // Passa o nome da página clicada
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default TopMenu;
